module.exports = __webpack_public_path__ + "img/ct_mobile@2x.daa9438b.png";